import colors from './colors';
import icons from './icons';
import spacing from './spacing';
import typography from './typography';
import zIndex from './zIndex';

export { colors, icons, spacing, typography, zIndex };
